module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "700",
      "content-class": "new-user-dialog",
      "persistent": _vm.step === 'usersAssignment' || _vm.step === 'copyInvitation'
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "dialog-card"
  }, [(_vm.step === 'question') ? [_c('v-card-title', {
    staticClass: "new-user-dialog-title text-break mb-0 mt-0 text-center justify-center",
    attrs: {
      "tag": "p"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('AddUser.addUserDialog.questionTitle')) + "\n          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 text-end",
    attrs: {
      "cols": "2",
      "align-self": "start"
    }
  }, [_c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000"
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-1",
    attrs: {
      "align": "end",
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "disabled": !_vm.sortedOrganizationUsers.length,
      "block": "",
      "color": "#0098E1"
    },
    on: {
      "click": function($event) {
        return _vm.existingUsers()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddUser.addUserDialog.extistingUsers')))])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-1",
    attrs: {
      "align": "start",
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "block": "",
      "color": "#0098E1"
    },
    on: {
      "click": function($event) {
        return _vm.createUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddUser.addUserDialog.newUser')))])], 1)], 1), _vm._v(" "), (_vm.fromNewCampaign && _vm.campaignEditors.length) ? _c('div', {
    staticClass: "campaign-editors-section mt-6"
  }, [_c('p', {
    staticClass: "editors-title mb-2"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.editorsTitle')))]), _vm._v(" "), _vm._l((_vm.campaignEditors), function(editor) {
    return _c('v-row', {
      key: editor.id,
      staticClass: "editor-invite-row",
      attrs: {
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "py-2 pr-2 text-left",
      attrs: {
        "cols": "7"
      }
    }, [_c('p', {
      staticClass: "mb-0 linked-user-name"
    }, [_vm._v(_vm._s(editor.name) + " " + _vm._s(editor.lastName || ''))])]), _vm._v(" "), _c('v-col', {
      staticClass: "py-2 d-flex justify-center",
      attrs: {
        "cols": "5"
      }
    }, [_c('v-btn', {
      staticClass: "copy-invitation-button",
      attrs: {
        "color": "#0098E1",
        "small": "",
        "outlined": "",
        "loading": _vm.copyingInvitationUserId === editor.id
      },
      on: {
        "click": function($event) {
          return _vm.copyInvitationLink(editor.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-content-copy")]), _vm._v("\n                " + _vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.copyInvitationLink')) + "\n              ")], 1)], 1)], 1)
  })], 2) : _vm._e()], 1)] : (_vm.step === 'usersAssignment') ? [_c('v-card-title', {
    staticClass: "new-user-dialog-title text-break mb-0 mt-0 text-center justify-center",
    attrs: {
      "tag": "p"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('AddUser.addUserDialog.usersAssignmentTitle')) + "\n          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 text-end",
    attrs: {
      "cols": "2",
      "align-self": "start"
    }
  }, [_c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000"
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-0 dialog-content"
  }, [_c('v-row', {
    staticClass: "scrollable-content",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.sortedOrganizationUsers,
      "hide-no-data": "",
      "outlined": "",
      "multiple": "",
      "filled": "",
      "hide-selected": "",
      "hide-details": "",
      "chips": "",
      "item-text": function (e) { return ((e.name) + " " + (e.lastName)); },
      "item-value": "id",
      "prepend-inner-icon": "mdi-magnify",
      "background-color": "#FFF",
      "color": "#0098E1",
      "menu-props": "auto",
      "label": ((_vm.$t('AddUser.addUserDialog.searchUser')) + "..."),
      "single-line": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', _vm._b({
          attrs: {
            "input-value": data.selected,
            "close": "",
            "medium": "",
            "color": "#EEF2F5"
          },
          on: {
            "click": data.select,
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, 'v-chip', data.attrs, false), [_vm._v("\n                " + _vm._s(data.item.name) + " " + _vm._s(data.item.lastName || '') + "\n              ")])]
      }
    }]),
    model: {
      value: (_vm.assignedUsers),
      callback: function($$v) {
        _vm.assignedUsers = $$v
      },
      expression: "assignedUsers"
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "color": "#0098E1",
      "loading": _vm.loadingLinkUsers
    },
    on: {
      "click": function($event) {
        return _vm.linkUsers()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('AddUser.addUserDialog.linkUsers')))])], 1)], 1)] : (_vm.step === 'copyInvitation') ? [_c('v-card-title', {
    staticClass: "new-user-dialog-title text-break mb-0 mt-0 text-center justify-center",
    attrs: {
      "tag": "p"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.usersLinkedCopyTitle')) + "\n          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 text-end",
    attrs: {
      "cols": "2",
      "align-self": "start"
    }
  }, [_c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000"
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-0 dialog-content"
  }, [_c('p', {
    staticClass: "text-center mb-4 users-linked-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.usersLinkedCopySubtitle')))]), _vm._v(" "), _vm._l((_vm.linkedUsersForCopy), function(user) {
    return _c('v-row', {
      key: user.id,
      staticClass: "mb-2 editor-invite-row",
      attrs: {
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "py-1 pr-2 text-left",
      attrs: {
        "cols": "7"
      }
    }, [_c('p', {
      staticClass: "mb-0 linked-user-name"
    }, [_vm._v(_vm._s(user.name) + " " + _vm._s(user.lastName || ''))])]), _vm._v(" "), _c('v-col', {
      staticClass: "py-1 d-flex justify-center",
      attrs: {
        "cols": "5"
      }
    }, [_c('v-btn', {
      staticClass: "copy-invitation-button",
      attrs: {
        "color": "#0098E1",
        "small": "",
        "outlined": "",
        "loading": _vm.copyingInvitationUserId === user.id
      },
      on: {
        "click": function($event) {
          return _vm.copyInvitationLink(user.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-content-copy")]), _vm._v("\n              " + _vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.copyInvitationLink')) + "\n            ")], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "color": "#0098E1"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('NewCampaignInitialData.devicesAndServices.continue')) + "\n          ")])], 1)], 2)] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d3be0e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddUser/AddUserDialog.vue
// module id = 1727
// module chunks = 0